// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill"
import Vue from 'vue'
import App from './App'
import router from '@/router/router'

import axios from 'axios'
Vue.prototype.$ajax = axios

import '@/assets/css/style.css'
import '@/assets/css/select.css'
import aes from '@/assets/js/aes.js';
import SIdentify from '@/components/identity'

import VueWechatTitle from 'vue-wechat-title';
Vue.use(VueWechatTitle)
Vue.component("SIdentify",SIdentify)

import global_ from './components/Global'//引用文件
Vue.prototype.GLOBAL = global_//挂载到Vue实例上面

// Vue.prototype.tongji = tongji

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

// import  VueQuillEditor from 'vue-quill-editor'
// // require styles 引入样式
// import 'quill/dist/quill.core.css'
// import 'quill/dist/quill.snow.css'
// import 'quill/dist/quill.bubble.css'

// Vue.use(VueQuillEditor)

// 添加请求拦截器
axios.interceptors.request.use(function (config) {
  // 对所有POST请加密，必须是json数据提交，不支持表单
	if (config.method == "post") {
    if(config.data == null){
      config.data = {};
    }
    config.data.reqSource ='web';
    config.data.serverSource = "web118";
    let url = config.url;
    if(url.indexOf("?") ==-1){
      url = url + "?t="+(new Date().getTime());
    }else{
      url = url + "&t="+(new Date().getTime());
    }
    config.url = url;
    // console.log(config.data);
    config.data = aes.e(JSON.stringify(config.data),'uwCy28301kdy%$12','982jelw103s()283');
    // console.log(config.data);
	}
    return config;
  }, function (error) {
    return Promise.reject(error);
});

// 添加响应拦截器
axios.interceptors.response.use(function (response) {
  // 后端返回字符串表示需要解密操作
  // console.log(JSON.stringify(response))
  // console.log(typeof(response.data) + ":" + response.data);

	if(typeof(response.data) == "string"){    
    response.data = eval('(' + aes.d(response.data,'uwCy28301kdy%$12','982jelw103s()283') + ')');
    //console.log(JSON.stringify(response.data));
  }
  if (response.data.code == '0000005'){
		router.replace({
        path: '/',
        query: {redirect: router.currentRoute.fullPath}
    })
  }
  // if("0000005" == response.data.code){
  //   router.push('/')
  //   return
  // }
    return response;
  }, function (error) {
	return Promise.reject(error);
});

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js